import { render, staticRenderFns } from "./fileShowDialog.vue?vue&type=template&id=920ffdba&"
import script from "./fileShowDialog.vue?vue&type=script&lang=js&"
export * from "./fileShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports